import React from "react";

export default function CustomInput({
  readOnly,
  name,
  onChange,
  checked,
  type,
}) {
  return (
    <input
      readOnly={readOnly}
      type={type}
      name={name}
      className="w-4 h-4 text-blue-600 bg-gray-50 border-gray-200 rounded focus:ring-blue-500"
      onChange={onChange}
      {...(checked !== undefined ? { checked } : {})}
    />
  );
}